import { render, staticRenderFns } from "./OrgsView.vue?vue&type=template&id=86901a4e&"
import script from "./OrgsView.vue?vue&type=script&lang=js&"
export * from "./OrgsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports